module.exports = __webpack_public_path__ + "static/true-flow-1a5be8edf9e9aee78e8cf1e567873603.jpg";